export const getPosition = (time) => {
  if (time > 3 && time < 21) return "th";
  switch (time % 10) {
    case 1:
      return "st";
    case 2:
      return "nd";
    case 3:
      return "rd";
    default:
      return "th";
  }
};

export const getBackground = (status, isDelayed = false) => {
  console.log("status34", status);
  if(isDelayed){
    return "rgb(239, 135, 76)";
  }

  if (
    status === "Cancelled" ||
    status === "Failed Delivered" ||
    status === "Failed Delivered Non-RTO" ||
    status === "RTO In-Transit" ||
    status === "RTO Out for Delivery" ||
    status === "RTO Delivered" ||
    status === "RTO Not Delivered" ||
    status === "RTO Delivery Delay"
  ) {
    return "#EE6C4D";
  } else if (status === "Delivery Delay") {
    return "#EF874C";
  }
  return "#126782";
};

// A suborder can carry many products, so flatten orderDetail into one row per item.
export const getOrderItems = (orderDetail) =>
  (orderDetail ?? []).flatMap((suborder) => {
    const items = suborder?.items ?? [];
    // Older shipments have no item breakdown - fall back to the suborder row.
    if (items.length === 0) {
      return [
        {
          key: `suborder-${suborder?.suborder_id}`,
          name: "NA",
          quantity: suborder?.quantity,
          value: suborder?.suborder_value ?? "NA",
        },
      ];
    }
    return items.map((item, index) => ({
      key: `item-${item?.id ?? `${suborder?.suborder_id}-${index}`}`,
      name: item?.name ?? item?.description ?? "NA",
      quantity: item?.quantity ?? suborder?.quantity,
      value: item?.item_value ?? "NA",
    }));
  });

// Order value and item count, as consumed by the [total, quantity, ...] orderData tuple.
export const getOrderSummary = (orderDetail) => {
  const total = (orderDetail ?? []).reduce(
    (sum, suborder) => sum + (parseFloat(suborder?.suborder_value) || 0),
    0
  );
  const quantity = getOrderItems(orderDetail).reduce(
    (sum, item) => sum + (parseInt(item?.quantity, 10) || 0),
    0
  );
  return { total: total.toFixed(2), quantity };
};
